import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

type VisibilityChecker = (controlName: string, control: AbstractControl) => boolean;

export function markEmptyFieldsAsUntouched(
  formGroup: FormGroup | FormArray,
  options?: {
    checkVisibility?: boolean; // Domyślnie: false
    isControlVisible?: VisibilityChecker; // Użytkownik może przekazać funkcję
  }
): void {
  const controls = formGroup instanceof FormGroup || formGroup instanceof FormArray ? formGroup.controls : {};

  Object.entries(controls).forEach(([key, control]) => {
    const value = control.value;

    if (control instanceof FormGroup || control instanceof FormArray) {
      markEmptyFieldsAsUntouched(control, options);
      return;
    }

    let isVisible = true;
    if (options?.checkVisibility && typeof options.isControlVisible === 'function') {
      isVisible = options.isControlVisible(key, control);
    }

    if (isVisible && (value === '' || value === null || value === undefined)) {
      control.markAsUntouched();
      control.updateValueAndValidity({ onlySelf: true });
    }
  });
}

// export function markEmptyFieldsAsUntouched(formGroup: FormGroup): void {
//   Object.keys(formGroup.controls).forEach((key) => {
//     const control = formGroup.get(key);

//     if (control instanceof FormControl) {
//       const value = control.value;

//       if (value === '' || value === null || value === undefined) {
//         control.markAsUntouched();
//         control.updateValueAndValidity({ onlySelf: true });
//       }
//     } else if (control instanceof FormGroup) {
//       markEmptyFieldsAsUntouched(control);
//     }
//   });
// }
